import React from 'react'
import PropTypes from 'prop-types'
import { Box, Flex } from '@chatterbug/aaron'
import { t } from 'src/lib/i18n-react'

import CEFRSeal from 'src/components/CEFRSeal/CEFRSeal'
import upArrow from 'src/ui/assets/icons/up-arrow.svg'
import downArrow from 'src/ui/assets/icons/down-arrow.svg'

const CourseSelectorToggle = ({ showPopout, course, onClick, buttonRef }) => {
  return (
    <Flex
      ref={buttonRef}
      as="button"
      justifyContent="center"
      alignItems="center"
      borderRadius="1,5x"
      borderColor="gray88"
      borderWidth="small"
      borderStyle="solid"
      boxShadow={showPopout && 'raised'}
      padding="1x"
      paddingRight="4x"
      bg="white100"
      backgroundImage={`url(${showPopout ? upArrow : downArrow})`}
      sx={{
        ':focus': {
          boxShadow: 'darkFocusRing',
          outline: 'none',
        },
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'right .7em center',
      }}
      aria-expanded={showPopout}
      aria-haspopup="true"
      aria-label={t('other courses')}
      onClick={onClick}
      showPopout={showPopout}
    >
      <Box width="24px" height="24px" mr="1x">
        <CEFRSeal
          cefrLevel={course.code}
          progress={course?.cefrLevelProgress}
          altText={course.code}
        />
      </Box>
      <Box as="p" fontSize="14px" fontWeight="bold">
        {course.label}
      </Box>
    </Flex>
  )
}
CourseSelectorToggle.propTypes = {
  showPopout: PropTypes.bool,
  course: PropTypes.shape({
    code: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    cefrLevelProgress: PropTypes.number,
  }),
  onClick: PropTypes.func.isRequired,
  buttonRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]),
}

export default CourseSelectorToggle
